/**
 * Sélecteur devise header — menu flottant porté dans body (même principe que lgk-auto-translate).
 */
(function () {
  const panelHomes = new WeakMap();
  let openPanel = null;
  let openToggle = null;
  let openWrap = null;

  function isSidebarPanel(wrap) {
    return Boolean(wrap?.closest('.header-sidebar__footer'));
  }

  function rememberPanelHome(panel) {
    if (!panelHomes.has(panel)) {
      panelHomes.set(panel, { parent: panel.parentElement, next: panel.nextSibling });
    }
  }

  function restorePanelHome(panel) {
    const home = panelHomes.get(panel);
    if (!home?.parent) return;
    home.parent.insertBefore(panel, home.next || null);
  }

  function positionPanel(toggle, panel, wrap) {
    const rect = toggle.getBoundingClientRect();
    const openUp = isSidebarPanel(wrap);
    const gap = 6;

    panel.classList.add('lgk-currency__panel--floating');
    panel.style.position = 'fixed';
    panel.style.zIndex = '100000';
    panel.style.right = `${Math.max(8, window.innerWidth - rect.right)}px`;
    panel.style.left = 'auto';
    panel.style.minWidth = `${Math.max(rect.width, 200)}px`;

    if (openUp) {
      panel.style.top = 'auto';
      panel.style.bottom = `${Math.max(8, window.innerHeight - rect.top + gap)}px`;
      panel.style.maxHeight = `${Math.max(120, rect.top - gap - 12)}px`;
    } else {
      panel.style.bottom = 'auto';
      panel.style.top = `${rect.bottom + gap}px`;
      panel.style.maxHeight = `${Math.max(120, window.innerHeight - rect.bottom - gap - 12)}px`;
    }
  }

  function clearPanel(panel) {
    panel.classList.remove('lgk-currency__panel--floating');
    panel.style.position = '';
    panel.style.top = '';
    panel.style.bottom = '';
    panel.style.right = '';
    panel.style.left = '';
    panel.style.zIndex = '';
    panel.style.minWidth = '';
    panel.style.maxHeight = '';
  }

  function closeAll() {
    if (window.LGKTranslate?.closeAllPanels) window.LGKTranslate.closeAllPanels();
    document.querySelectorAll('[data-lgk-currency-panel]').forEach((panel) => {
      panel.hidden = true;
      clearPanel(panel);
      restorePanelHome(panel);
    });
    document.querySelectorAll('[data-lgk-currency-toggle]').forEach((toggle) => {
      toggle.setAttribute('aria-expanded', 'false');
    });
    openPanel = null;
    openToggle = null;
    openWrap = null;
  }

  function open(wrap, toggle, panel) {
    closeAll();
    rememberPanelHome(panel);
    document.body.appendChild(panel);
    positionPanel(toggle, panel, wrap);
    panel.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    openPanel = panel;
    openToggle = toggle;
    openWrap = wrap;
  }

  function reposition() {
    if (!openPanel || openPanel.hidden || !openToggle || !openWrap) return;
    positionPanel(openToggle, openPanel, openWrap);
  }

  function bind() {
    document.querySelectorAll('[data-lgk-currency]').forEach((wrap) => {
      const toggle = wrap.querySelector('[data-lgk-currency-toggle]');
      const panel = wrap.querySelector('[data-lgk-currency-panel]');
      if (!toggle || !panel) return;

      toggle.addEventListener('click', (e) => {
        e.stopPropagation();
        const willOpen = panel.hidden;
        closeAll();
        if (willOpen) open(wrap, toggle, panel);
      });
    });

    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-lgk-currency]') || e.target.closest('[data-lgk-currency-panel]')) return;
      closeAll();
    });

    window.addEventListener('resize', reposition);
    window.addEventListener('scroll', reposition, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }

  window.LGKCurrency = { closeAll };
})();
